export default __webpack_public_path__ + "static/media/coin.c8f3cb8d.svg";